// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eRyQ","placeholdersHeader":"styles_placeholdersHeader__wQ7bX","editorStyle":"styles_editorStyle__3QvJq","placeholdersBox":"styles_placeholdersBox__3oxxp"};